import './raster.scss'

import React from 'react'
import {style} from 'util/style'

const styles = style('raster')
export const Raster: React.FC<{
	className?: string
}> = ({...props}) => (
	<div className={styles.mergeProps(props)}>{props.children}</div>
)
